import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { MatLine } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { TeamViewModel } from '../../models/TeamModels';
import { PlayerService } from '../../services/player.service';
import { PlayerListService } from '../../services/player-list.service';
import { PlayerListListViewModel } from '../../models/PlayerListModels';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-select-ranking-list-dialog',
  standalone: true,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatSelectionList, MatListOption, MatLine, MatDialogActions, MatButton, MatDialogClose, TranslatePipe, UpperCasePipe],
  templateUrl: './select-ranking-list-dialog.component.html',
  styleUrl: './select-ranking-list-dialog.component.css'
})
export class SelectRankingListDialogComponent {

  private playerListSrv = inject(PlayerListService);

  readonly playerlists = toSignal(this.playerListSrv.getLists(), {
    initialValue: [] as PlayerListListViewModel[]
  });

  selectedListId(list: MatSelectionList){
    const selected = list.selectedOptions.selected.map(o => o.value);
    if (selected.length > 0) {
      return selected;

    }
    else{
      return null;
    }
 
  }

  isSelected(list: MatSelectionList): boolean {
     const selected = list.selectedOptions.selected.map(o => o.value);
   return selected.length > 0;
  }

}
